import { render, staticRenderFns } from "./ProofreadingPopup.vue?vue&type=template&id=ee13271c&scoped=true"
import script from "./ProofreadingPopup.vue?vue&type=script&lang=ts"
export * from "./ProofreadingPopup.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingPopup.vue?vue&type=style&index=0&id=ee13271c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee13271c",
  null
  
)

export default component.exports